package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.db.tables.SeriesCategoryWithVisibleStatus
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesCategoryWithSize
import com.xtream.data_kmp.dto.seriesCategoriesTable
import com.xtream.data_kmp.dto.seriesStreamsTable
import com.xtream.data_kmp.seriesFavoritesTable
import com.xtream.data_kmp.watchedSeriesStreamsTable
import kotlinx.coroutines.flow.Flow


@Dao
abstract class SeriesCategoriesDao:RoomBaseInterface<SeriesCategory> {

    @Query("SELECT * FROM ${seriesCategoriesTable}")
    abstract override fun allAsFlow(): Flow<List<SeriesCategory>>
    @Query("""
        SELECT * FROM ${seriesCategoriesTable}
         WHERE CASE
         WHEN categoryId = ${AllConst.FAV_CATEGORIES_ID}
         THEN
            categoryId IN ( SELECT DISTINCT categoryId FROM ${seriesFavoritesTable})
         WHEN categoryId = ${AllConst.WATCHED_CATEGORIES_ID}
         THEN
            categoryId IN ( SELECT DISTINCT categoryId FROM ${watchedSeriesStreamsTable})
         ELSE
           categoryId IN ( SELECT DISTINCT categoryId FROM ${seriesStreamsTable})
         END
ORDER BY created_at 
         """)
    abstract override fun allAsPagingSource(): PagingSource<Int, SeriesCategory>



    @Query("SELECT * FROM ${seriesCategoriesTable}"
        // +"WHERE (:categoryId IS NULL OR categoryId = :categoryId)"

        /*+"ORDER BY sortOrder"*/)
    abstract fun getPagedCategories(): PagingSource<Int, SeriesCategory>



    @Query("SELECT EXISTS (SELECT 1 FROM ${seriesCategoriesTable} WHERE categoryId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM ${seriesCategoriesTable} WHERE categoryId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>

    @Query("SELECT COUNT(*) FROM ${seriesCategoriesTable}")
    abstract override suspend fun getSize(): Long?
    @Query("DELETE FROM seriesCategoriesTable")
    abstract override suspend fun deleteAll()

    @Query("""
    
    SELECT 
    category.*, 
    CASE 
        WHEN category.categoryId = -2 THEN (SELECT COUNT(streamId) FROM ${seriesFavoritesTable})
        WHEN category.categoryId = -3 THEN (SELECT COUNT(streamId) FROM ${watchedSeriesStreamsTable})
        ELSE (SELECT COUNT(streamId) FROM ${seriesStreamsTable} WHERE categoryId = category.categoryId)
    END AS size  
FROM ${seriesCategoriesTable} AS category
GROUP BY category.categoryId
ORDER BY category.created_at
""")
    abstract fun getPagingCategoriesWithSize(): PagingSource<Int, SeriesCategoryWithSize>

    @Query("""
    SELECT c.*,
           CASE WHEN h.categoryId IS NULL THEN 0 ELSE 1 END AS isHidden
    FROM seriesCategoriesTable c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId
       AND h.type = 'SERIES'
""")
    abstract fun getCategoriesWithVisibleStatus():
            Flow<List<SeriesCategoryWithVisibleStatus>>
}